export const getCountryCookie = () => {
  try {
    return (
      document.cookie
        .split('; ')
        .find((row) => row.startsWith('country='))
        ?.split('=')[1] || null
    );
  } catch (error) {
    console.error('Error parsing cookie:', error);
    return null;
  }
};

export default getCountryCookie;
